import {RiCollapseVerticalLine, RiExpandVerticalLine} from "react-icons/ri";
import {SecondaryButton} from "../../../general/SecondaryButton.tsx";

interface ExpandCollapseButtonProps {
    beyondDefault: boolean;
    disabled: boolean;
    onClick: () => void;
}

export function ExpandCollapseButton({
    beyondDefault,
    disabled,
    onClick,
}: ExpandCollapseButtonProps) {
    return (
        <SecondaryButton
            title={beyondDefault ? "Alles inklappen" : "Alles uitklappen"}
            icon={beyondDefault ? RiCollapseVerticalLine : RiExpandVerticalLine}
            onClick={onClick}
            disabled={disabled}
        />
    );
}
